import { render, staticRenderFns } from "./sertifikatBimtek.vue?vue&type=template&id=09ebdba8"
import script from "./sertifikatBimtek.vue?vue&type=script&lang=js"
export * from "./sertifikatBimtek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports